// On the PO, TopicsAppContainer and EventsAppStandalone are independent of one another.
// In order to support navigation between the two when we hit a URL that is not handled by the currently

import { useEffect } from 'react';

import { dynamicTopicResourcePath } from 'hb-react/shared/apps/Topics/utils';
import { captureException } from 'hb-react/shared/utils/errorReporting';

// TODO: Temporary workaround i'll open PR to type global Hivebrite object.
type GlobalHivebrite = typeof window & {
  Hivebrite: {
    topic: {
      id: number;
      whitelabelName: string;
      whitelabelURL: string;
    };
  };
};

// loaded app we force a reload and let the server load the other app so it can handle the requested URL.
export const NoMatch = () => {
  useEffect(() => {
    const hivebrite = (window as GlobalHivebrite).Hivebrite;

    if (
      hivebrite.topic &&
      hivebrite.topic.whitelabelName &&
      hivebrite.topic.whitelabelName !== window.location.host
    ) {
      const redirect = new URL(
        window.location.href.replace(
          window.location.host,
          hivebrite.topic.whitelabelName,
        ),
      );

      redirect.pathname = dynamicTopicResourcePath(redirect.pathname, {
        topicId: hivebrite.topic?.id,
        whitelabelURL: hivebrite.topic?.whitelabelURL,
      });

      captureException({
        message: 'NoMatch / Redirecting to the whitelabel topic page',
        extra: {
          redirect,
          location: window.location.href,
          topic: hivebrite.topic,
        },
      });

      window.location.assign(redirect);
    } else {
      captureException({
        message: 'NoMatch / Reloading the page',
        extra: {
          location: window.location.href,
          topic: hivebrite.topic,
        },
      });

      window.location.reload();
    }
  }, []);

  return null;
};
